var map = {
	"./notice1.mp3": "6cd2",
	"./notice10.mp3": "2f43",
	"./notice2.mp3": "8340",
	"./notice3.mp3": "2850",
	"./notice4.mp3": "08e2",
	"./notice5.mp3": "9927",
	"./notice6.mp3": "d538",
	"./notice7.mp3": "efb5",
	"./notice8.mp3": "442f",
	"./notice9.mp3": "1281",
	"./notice_1.mp3": "8db9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49d2";